// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCEhjRjXj9sks1aUFkYWh1gdJkxvzLw-Ho",
  authDomain: "univibes-2649b.firebaseapp.com",
  databaseURL: "https://univibes-2649b-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "univibes-2649b",
  storageBucket: "univibes-2649b.appspot.com",
  messagingSenderId: "569670644119",
  appId: "1:569670644119:web:c29e1b5ae113e54db214d2",
  measurementId: "G-WL8LX25GZE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);


export {app, db, analytics};